var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeWorkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3632_98642",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3632_98642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8065 12.1768H24.9361V10.0472H22.8065V12.1768ZM22.8065 17.5222H24.9361V15.3926H22.8065V17.5222ZM22.8065 22.8463H24.9361V20.7167H22.8065V22.8463ZM21.6139 28V25.8704H27.9815V7.12961H15.7361V10.1111L13.6065 8.59912V5H30.1111V28H21.6139ZM2 28V15.4352L10.7528 9.17408L19.4842 15.4352V28H12.3074V21.5898H9.19814V28H2ZM4.12961 25.8704H7.06853V19.4602H14.437V25.8704H17.3546V16.5213L10.7528 11.7935L4.12961 16.5303V25.8704Z",
    fill: "#054BC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWorkBlue);
export default __webpack_public_path__ + "static/media/home_work-blue.435103cdb170673bdc62da961de0109e.svg";
export { ForwardRef as ReactComponent };